import styles from './styles.module.scss';
import { FC, Props } from './typings';

const GenericNavbar: FC<Props> = ({
  firstElement,
  secondElement,
  selected,
  onClickFirstElement,
  onClickSecondElement,
}) => {
  return (
    <div className={styles.switchbox}>
      <div
        onClick={onClickFirstElement}
        className={`${styles.switch} ${selected === 0 && styles.active}`}
      >
        {firstElement}
      </div>
      <div
        onClick={onClickSecondElement}
        className={`${styles.switch} ${selected === 1 && styles.active}`}
      >
        {secondElement}
      </div>
    </div>
  );
};

export default GenericNavbar;
